// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"LargeImage_imageContainer__1c0dK"};